import bisratHuaweiImage from '../assets/svg/experience/bisrat-huawei-1.png'
import bisratRapidhackathonImage from '../assets/svg/experience/bisrat-rapid-hackathon.png'

export const achievementData = {
    bio : "Check out some of the awesome things I've accomplished so far! From winning awards to completing challenging projects",
    achievements : [
        {
            id : 1,
            title : 'Huawei Cloud Computing - First Prize Winner',
            details : `This Certiﬁcate was awarded from Huawei for ranking 1st in National competition on Cloud computing.`,
            date : 'Aug 26, 2022',
            field : 'Cloud Computing',
            // image : 'https://images.unsplash.com/photo-1573141597928-403fcee0e056?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=667&q=80'
            image: bisratHuaweiImage
        },
        {
            id : 2,
            title : 'Rapid One API Global Challenge',
            details : 'I have successfully completed and have won the bronze place on the challenge',
            date : 'Dec 20, 2021',
            field : 'API',
            // image : 'https://images.unsplash.com/photo-1523474253046-8cd2748b5fd2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
            image: bisratRapidhackathonImage
        },
        {
            id : 3,
            title : 'Professional Data Engineer Certification',
            details : 'Professional Data Engineers enable data-driven decision making by collecting, transforming, and publishing data.',
            date : 'Aug 20, 2019',
            field : 'Automation',
            image : 'https://images.unsplash.com/photo-1489389944381-3471b5b30f04?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/